import '../sass/style.scss';
import SimpleSlider from './simple-slider';
import initMap from './mapbox-map';

let headerHeight = 0;

function scrollTo(anchor) {
    const $target = jQuery(anchor);
    let offset = 0;
    if ($target.length) {
        offset = $target.offset().top - 168;
    }
    // Minimize Mobile nav if expanded
    jQuery('#site-navigation').removeClass('toggled').find('.menu').attr('aria-expanded', false);

    jQuery('html, body').animate({
        'scrollTop': offset
    }, 500, 'swing');
}

let onReadyJobs = [];

function queueFunc(callable, ...args) {
    onReadyJobs.push({callable, args: args});
}

if (window.location.hash.length > 0) {
    console.log('queued');
    queueFunc(scrollTo, window.location.hash);
}

function updateAddToCartButton($that) {
    if (typeof $that === typeof undefined) {
        return;
    }
    let $this = $that;
    if (!$that.hasClass('add_to_cart_button')) {
        $this = jQuery('.add_to_cart_button[data-product_id="' + $that.data('product_id') + '"]');
    }
    jQuery.post(dmode.ajaxurl, {
            action: 'update_add_to_cart_btn',
            productId: $this.data('product_id')
        },
        (res) => {
            if (res) {
                $this.parents('.product').toggleClass('in-cart');

                $this.replaceWith(jQuery(res));
                resetCartButtonHandlers();
            }
        });
}

function ajaxRemoveProductFromCart(e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const $this = jQuery(this);

    jQuery.post(
        dmode.wcAjaxBase.toString().replace('%%endpoint%%', 'remove_from_cart'),
        {
            cart_item_key: $this.data('cart_item_key')
        },
        (res) => {
            console.log(res);
            if (!res || !res.fragments) {
                window.location = $this.attr('href');
                return;
            }

            jQuery(document.body).trigger('removed_from_cart', [res.fragments, res.cart_hash, $this]);
        });

    return false;
}

function resetCartButtonHandlers() {
    jQuery('.in-cart > .add_to_cart_button, .in-cart > .entry-summary .add_to_cart_button')
        .off('click', ajaxRemoveProductFromCart)
        .on('click', ajaxRemoveProductFromCart);
}

jQuery(document).ready(() => {
    for (let j of onReadyJobs) {
        j.callable(...j.args);
    }

    jQuery('a[href*="#"]').click(function (e) {
        if ((e.target.href.charAt(0) === '#') || ((e.target.origin + e.target.pathname) === (window.location.origin + window.location.pathname))) {
            e.preventDefault();

            scrollTo(e.target.hash);

            return false;
        }
    });

    resetCartButtonHandlers();

    const $wideContainers = jQuery('.block-wide');
    if ($wideContainers.length) {
        const scrollBarWidth = getScrollbarWidth();
        $wideContainers.css({
            marginLeft: `calc((-100vw + ${1200 + scrollBarWidth}px) / 2)`,
            marginRight: `calc((-100vw + ${1200 + scrollBarWidth}px) / 2)`,
        })
    }


    if (jQuery('.subcategory-slider-wrap').length) {
        const Slider = new SimpleSlider('.subcategory-slider-wrap');
    } else if (jQuery('.single-product .woocommerce-product-gallery').length) {
        const Slider = new SimpleSlider('.woocommerce-product-gallery');
    }

    jQuery('.share-toggle').click(function () {
        jQuery(this).parent().toggleClass('toggled');
    });

    jQuery('.search-toggle').click(function () {
        const $input = jQuery(this).parent().toggleClass('toggled').find('#site-search-input');
        $input.get(0).setSelectionRange(0, $input.val().length);
    });

    jQuery('#primary-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children')
        .click(function(e) {
            const $this = jQuery(this);
            $this.toggleClass('toggled');
    });

    if (jQuery('#dmode-map').length) {
        initMap('dmode-map');
    }

    const $doc = jQuery(document);

    headerHeight = jQuery('.site-header').height() + jQuery('.top-bar').height() + jQuery('.woocommerce-breadcrumb').height();

    if (jQuery('.single-product .product-type-grouped').length) {
        $doc.on('scroll', stickyGallery);
    } else if (jQuery('.single-product .product-type-simple').length) {
        $doc.on('scroll', stickySummary);
    }
});
jQuery(window).resize(() => {
    headerHeight = jQuery('.site-header').height() + jQuery('.top-bar').height() + jQuery('.woocommerce-breadcrumb').height();
});

function stickyGallery(e) {
    const measure = jQuery('.entry-summary').height() + headerHeight;
    const $sticky = jQuery('.woocommerce-product-gallery');

    stickySection($sticky, measure);
}

function stickySummary(e) {
    const measure = jQuery('.woocommerce-product-gallery').height() + headerHeight;
    const $sticky = jQuery('.entry-summary');

    stickySection($sticky, measure);
}

function stickySection($section, measure) {
    if (window.scrollY >= (measure - window.innerHeight + headerHeight)) {
        $section.css('top', `${(measure - (window.innerHeight - 2.5*headerHeight)) - window.scrollY}px`);
    } else {
        $section.css('top', 'unset');
    }
}

jQuery(document).on('added_to_cart removed_from_cart', (e, frag, hash, $this) => updateAddToCartButton($this));

jQuery(document).on('wc_cart_button_updated removed_from_cart', () => {
    const removeShowCartNotice = (dClick) => {
        jQuery('.added_to_cart.wc-forward').remove();
        jQuery(document).off('click', dClick);
    };

    const dClick = jQuery(document).on('click', () => removeShowCartNotice(dClick));
    setTimeout(() => removeShowCartNotice(dClick), 3000);

    jQuery.post(
        dmode.ajaxurl,
        {
            action: 'update_tiny_cart'
        },
        (res) => {
            if (res.length > 1) {
                jQuery('.mini-cart-wrap').replaceWith(jQuery(res));
            }
        },
        'html'
    );
});


function getScrollbarWidth() {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    outer.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(outer);
  
    const inner = document.createElement('div');
    outer.appendChild(inner);
    
    const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);
  
    outer.parentNode.removeChild(outer);
  
    return scrollbarWidth;
  }
